import React, { useRef } from 'react';
import { useIntl } from 'react-intl';

import { Button } from 'components/button/Button';
import { FormError } from 'containers/forms/FormError';

import s from './UploadInput.module.scss';

type Props = {
  buttonText?: string;
  fileName?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const UploadInput = (props: Props) => {
  const { fileName, buttonText, ...rest } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  const intl = useIntl();

  return (
    <div className={s.uploadInput}>
      <Button icon="upload" type="button" onClick={() => inputRef.current?.click()}>
        {buttonText ? buttonText : intl.formatMessage({ id: 'upload_choose_files' })}
      </Button>
      <input type="file" ref={inputRef} {...rest} />
      <span className={s.uploadInput__fileText}>
        {fileName ? fileName : intl.formatMessage({ id: 'upload_no_files' })}
      </span>
      {rest.name && (
        <div className={s.uploadInput__errorWrap}>
          <FormError name={rest.name} />
        </div>
      )}
    </div>
  );
};
